// pageTop：ページトップへのスクロール

export default function pageTop(){
  var $pageTop = $('.js-pageTop');
  $pageTop.on('click', function(){
    $('body,html').stop().animate({scrollTop:0}, 'slow', 'swing');
    return false;
  });
}



// WEBPACK FOOTER //
// ./js/module/pageTop.js